/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddUsersToOrganizationBody } from '../models';
// @ts-ignore
import type { AdminCreateChatTemplateBody } from '../models';
// @ts-ignore
import type { BulkUpdateOrgBody } from '../models';
// @ts-ignore
import type { CreateChatTemplateBody } from '../models';
// @ts-ignore
import type { CreateOrganizationBody } from '../models';
// @ts-ignore
import type { CreatePlanResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FileUploadResponse } from '../models';
// @ts-ignore
import type { GetAllChatTemplatesResponse } from '../models';
// @ts-ignore
import type { GetAllPlansResponse } from '../models';
// @ts-ignore
import type { GetChatTemplateResponse } from '../models';
// @ts-ignore
import type { GetOrgListResponse } from '../models';
// @ts-ignore
import type { GetOrganizationListSub } from '../models';
// @ts-ignore
import type { GetOrganizationUsersListResponse } from '../models';
// @ts-ignore
import type { InviteOrgMembersBody } from '../models';
// @ts-ignore
import type { MemberAcceptanceBody } from '../models';
// @ts-ignore
import type { OrgAutocompleteResponse } from '../models';
// @ts-ignore
import type { OrganizationContactDetailsResponse } from '../models';
// @ts-ignore
import type { OrganizationResponse } from '../models';
// @ts-ignore
import type { ReviewOrganizationResponse } from '../models';
// @ts-ignore
import type { RoleChangeBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { TeamNameAvailibilityResponse } from '../models';
// @ts-ignore
import type { UpdateOrgToPremiumBody } from '../models';
// @ts-ignore
import type { UpdateOrgUserBody } from '../models';
// @ts-ignore
import type { UpdateOrganizationBody } from '../models';
/**
 * OrganizationApiApi - axios parameter creator
 */
export const OrganizationApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiActivateOrganizationStatus: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiActivateOrganizationStatus', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/activate`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AddUsersToOrganizationBody} addUsersToOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAddUserToOrganization: async (orgId: string, addUsersToOrganizationBody: AddUsersToOrganizationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiAddUserToOrganization', 'orgId', orgId)
            // verify required parameter 'addUsersToOrganizationBody' is not null or undefined
            assertParamExists('organizationApiAddUserToOrganization', 'addUsersToOrganizationBody', addUsersToOrganizationBody)
            const localVarPath = `/org/{org_id}/add-user-to-org`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUsersToOrganizationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminCreateChatTemplateBody} adminCreateChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminCreateChatTemplate: async (adminCreateChatTemplateBody: AdminCreateChatTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateChatTemplateBody' is not null or undefined
            assertParamExists('organizationApiAdminCreateChatTemplate', 'adminCreateChatTemplateBody', adminCreateChatTemplateBody)
            const localVarPath = `/admin/chat/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateChatTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminDeleteChatTemplateById: async (chatTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiAdminDeleteChatTemplateById', 'chatTemplateId', chatTemplateId)
            const localVarPath = `/admin/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminGetChatTemplateById: async (chatTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiAdminGetChatTemplateById', 'chatTemplateId', chatTemplateId)
            const localVarPath = `/admin/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminGetChatTemplateList: async (page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {AdminCreateChatTemplateBody} adminCreateChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminUpdateChatTemplateById: async (chatTemplateId: string, adminCreateChatTemplateBody: AdminCreateChatTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiAdminUpdateChatTemplateById', 'chatTemplateId', chatTemplateId)
            // verify required parameter 'adminCreateChatTemplateBody' is not null or undefined
            assertParamExists('organizationApiAdminUpdateChatTemplateById', 'adminCreateChatTemplateBody', adminCreateChatTemplateBody)
            const localVarPath = `/admin/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateChatTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateOrgBody} bulkUpdateOrgBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiBulkUpdateOrganizationStatus: async (bulkUpdateOrgBody: BulkUpdateOrgBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateOrgBody' is not null or undefined
            assertParamExists('organizationApiBulkUpdateOrganizationStatus', 'bulkUpdateOrgBody', bulkUpdateOrgBody)
            const localVarPath = `/org/bulk-update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateOrgBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {RoleChangeBody} roleChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiChangeOrgUserRole: async (orgId: string, roleChangeBody: RoleChangeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiChangeOrgUserRole', 'orgId', orgId)
            // verify required parameter 'roleChangeBody' is not null or undefined
            assertParamExists('organizationApiChangeOrgUserRole', 'roleChangeBody', roleChangeBody)
            const localVarPath = `/org/{org_id}/role-change`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleChangeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateChatTemplateBody} createChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiCreateChatTemplate: async (orgId: string, createChatTemplateBody: CreateChatTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiCreateChatTemplate', 'orgId', orgId)
            // verify required parameter 'createChatTemplateBody' is not null or undefined
            assertParamExists('organizationApiCreateChatTemplate', 'createChatTemplateBody', createChatTemplateBody)
            const localVarPath = `/org/{org_id}/chat/template`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOrganizationBody} createOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiCreateOrganization: async (createOrganizationBody: CreateOrganizationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrganizationBody' is not null or undefined
            assertParamExists('organizationApiCreateOrganization', 'createOrganizationBody', createOrganizationBody)
            const localVarPath = `/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganizationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiDeleteChatTemplateById: async (chatTemplateId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiDeleteChatTemplateById', 'chatTemplateId', chatTemplateId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiDeleteChatTemplateById', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetChatTemplateById: async (chatTemplateId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiGetChatTemplateById', 'chatTemplateId', chatTemplateId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetChatTemplateById', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetChatTemplateList: async (orgId: string, page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetChatTemplateList', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/template`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetCompanyAccessibleUsers: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationApiGetCompanyAccessibleUsers', 'companyId', companyId)
            const localVarPath = `/company/{company_id}/accessible-users`
                .replace('{company_id}', encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrgUser: async (orgId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetOrgUser', 'orgId', orgId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationApiGetOrgUser', 'userId', userId)
            const localVarPath = `/org/{org_id}/user/{user_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationById: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetOrganizationById', 'orgId', orgId)
            const localVarPath = `/org/{org_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attribute 
         * @param {string} [orgId] 
         * @param {string} [orgUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationContactDetails: async (attribute: string, orgId?: string, orgUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attribute' is not null or undefined
            assertParamExists('organizationApiGetOrganizationContactDetails', 'attribute', attribute)
            const localVarPath = `/org/contact-details/{attribute}`
                .replace('{attribute}', encodeURIComponent(String(attribute)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (orgUserId !== undefined) {
                localVarQueryParameter['org_user_id'] = orgUserId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [document] 
         * @param {string} [endDate] 
         * @param {OrganizationApiGetOrganizationCsvFreeUnlockEnum} [freeUnlock] 
         * @param {string | null} [freeUnlockOfferId] 
         * @param {number | null} [maxJobPosted] 
         * @param {number | null} [minApplicants] 
         * @param {number | null} [minJobPosted] 
         * @param {string} [name] 
         * @param {string | null} [planType] 
         * @param {string} [startDate] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationCsv: async (document?: boolean, endDate?: string, freeUnlock?: OrganizationApiGetOrganizationCsvFreeUnlockEnum, freeUnlockOfferId?: string | null, maxJobPosted?: number | null, minApplicants?: number | null, minJobPosted?: number | null, name?: string, planType?: string | null, startDate?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/org-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (freeUnlock !== undefined) {
                localVarQueryParameter['free_unlock'] = freeUnlock;
            }

            if (freeUnlockOfferId !== undefined) {
                localVarQueryParameter['free_unlock_offer_id'] = freeUnlockOfferId;
            }

            if (maxJobPosted !== undefined) {
                localVarQueryParameter['max_job_posted'] = maxJobPosted;
            }

            if (minApplicants !== undefined) {
                localVarQueryParameter['min_applicants'] = minApplicants;
            }

            if (minJobPosted !== undefined) {
                localVarQueryParameter['min_job_posted'] = minJobPosted;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (planType !== undefined) {
                localVarQueryParameter['plan_type'] = planType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationList: async (name?: string, page?: string, pageSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationUsers: async (orgId: string, companyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetOrganizationUsers', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/users`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPendingOrganizationList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/org/membership-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPlanById: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('organizationApiGetPlanById', 'planId', planId)
            const localVarPath = `/plan/{plan_id}`
                .replace('{plan_id}', encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [planType] 
         * @param {string} [query] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPlanListPublic: async (page?: number, pageSize?: number, planType?: string, query?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (planType !== undefined) {
                localVarQueryParameter['plan_type'] = planType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [planType] 
         * @param {string} [query] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetTrialPlanList: async (page?: number, pageSize?: number, planType?: string, query?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plan/trial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (planType !== undefined) {
                localVarQueryParameter['plan_type'] = planType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetVerificationDoc: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiGetVerificationDoc', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/verification-doc`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiHardDeleteOrganization: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiHardDeleteOrganization', 'orgId', orgId)
            const localVarPath = `/org/{org_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {InviteOrgMembersBody} inviteOrgMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiInviteOrganizationMembers: async (orgId: string, inviteOrgMembersBody: InviteOrgMembersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiInviteOrganizationMembers', 'orgId', orgId)
            // verify required parameter 'inviteOrgMembersBody' is not null or undefined
            assertParamExists('organizationApiInviteOrganizationMembers', 'inviteOrgMembersBody', inviteOrgMembersBody)
            const localVarPath = `/org/{org_id}/invite-member`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteOrgMembersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiIsTeamNameAvailable: async (companyId: string, teamName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationApiIsTeamNameAvailable', 'companyId', companyId)
            // verify required parameter 'teamName' is not null or undefined
            assertParamExists('organizationApiIsTeamNameAvailable', 'teamName', teamName)
            const localVarPath = `/company/{company_id}/{team_name}/is_available`
                .replace('{company_id}', encodeURIComponent(String(companyId)))
                .replace('{team_name}', encodeURIComponent(String(teamName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiMarkOrganizationDelete: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiMarkOrganizationDelete', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/delete`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiOrgAutocomplete: async (pageNo?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/org/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiRemoveOrganizationMembers: async (email: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('organizationApiRemoveOrganizationMembers', 'email', email)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiRemoveOrganizationMembers', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/remove-member`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [document] 
         * @param {string | null} [endDate] 
         * @param {OrganizationApiReviewOrganizationsFreeUnlockEnum} [freeUnlock] 
         * @param {string | null} [freeUnlockOfferId] 
         * @param {boolean | null} [isPlacementPartner] 
         * @param {number | null} [maxJobPosted] 
         * @param {number | null} [minActivityCount] 
         * @param {number | null} [minApplicants] 
         * @param {number | null} [minJobPosted] 
         * @param {string | null} [orgId] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string | null} [planType] 
         * @param {string} [searchQuery] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiReviewOrganizations: async (document?: boolean, endDate?: string | null, freeUnlock?: OrganizationApiReviewOrganizationsFreeUnlockEnum, freeUnlockOfferId?: string | null, isPlacementPartner?: boolean | null, maxJobPosted?: number | null, minActivityCount?: number | null, minApplicants?: number | null, minJobPosted?: number | null, orgId?: string | null, page?: string, pageSize?: string, planType?: string | null, searchQuery?: string, sortBy?: string, sortOrder?: string, startDate?: string | null, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/org/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (freeUnlock !== undefined) {
                localVarQueryParameter['free_unlock'] = freeUnlock;
            }

            if (freeUnlockOfferId !== undefined) {
                localVarQueryParameter['free_unlock_offer_id'] = freeUnlockOfferId;
            }

            if (isPlacementPartner !== undefined) {
                localVarQueryParameter['is_placement_partner'] = isPlacementPartner;
            }

            if (maxJobPosted !== undefined) {
                localVarQueryParameter['max_job_posted'] = maxJobPosted;
            }

            if (minActivityCount !== undefined) {
                localVarQueryParameter['min_activity_count'] = minActivityCount;
            }

            if (minApplicants !== undefined) {
                localVarQueryParameter['min_applicants'] = minApplicants;
            }

            if (minJobPosted !== undefined) {
                localVarQueryParameter['min_job_posted'] = minJobPosted;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (planType !== undefined) {
                localVarQueryParameter['plan_type'] = planType;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiStartTrialPlan: async (orgId: string, planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiStartTrialPlan', 'orgId', orgId)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('organizationApiStartTrialPlan', 'planId', planId)
            const localVarPath = `/org/{org_id}/plan/{plan_id}/trial`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{plan_id}', encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newOwnerUserId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiTransferOwnership: async (newOwnerUserId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newOwnerUserId' is not null or undefined
            assertParamExists('organizationApiTransferOwnership', 'newOwnerUserId', newOwnerUserId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiTransferOwnership', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/ownership/{new_owner_user_id}`
                .replace('{new_owner_user_id}', encodeURIComponent(String(newOwnerUserId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiTriggerDocumentStatusMail: async (orgId: string, status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiTriggerDocumentStatusMail', 'orgId', orgId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('organizationApiTriggerDocumentStatusMail', 'status', status)
            const localVarPath = `/org/{org_id}/trigger-document-status-mail`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {MemberAcceptanceBody} memberAcceptanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateAcceptanceStatus: async (orgId: string, memberAcceptanceBody: MemberAcceptanceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateAcceptanceStatus', 'orgId', orgId)
            // verify required parameter 'memberAcceptanceBody' is not null or undefined
            assertParamExists('organizationApiUpdateAcceptanceStatus', 'memberAcceptanceBody', memberAcceptanceBody)
            const localVarPath = `/org/{org_id}/membership-acceptance`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberAcceptanceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {CreateChatTemplateBody} createChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateChatTemplateById: async (chatTemplateId: string, orgId: string, createChatTemplateBody: CreateChatTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatTemplateId' is not null or undefined
            assertParamExists('organizationApiUpdateChatTemplateById', 'chatTemplateId', chatTemplateId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateChatTemplateById', 'orgId', orgId)
            // verify required parameter 'createChatTemplateBody' is not null or undefined
            assertParamExists('organizationApiUpdateChatTemplateById', 'createChatTemplateBody', createChatTemplateBody)
            const localVarPath = `/org/{org_id}/chat/template/{chat_template_id}`
                .replace('{chat_template_id}', encodeURIComponent(String(chatTemplateId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateMemberResignation: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateMemberResignation', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/membership-resignation`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {UpdateOrganizationBody} updateOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganization: async (orgId: string, updateOrganizationBody: UpdateOrganizationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateOrganization', 'orgId', orgId)
            // verify required parameter 'updateOrganizationBody' is not null or undefined
            assertParamExists('organizationApiUpdateOrganization', 'updateOrganizationBody', updateOrganizationBody)
            const localVarPath = `/org/{org_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {UpdateOrgToPremiumBody} updateOrgToPremiumBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganizationToPremium: async (orgId: string, updateOrgToPremiumBody: UpdateOrgToPremiumBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateOrganizationToPremium', 'orgId', orgId)
            // verify required parameter 'updateOrgToPremiumBody' is not null or undefined
            assertParamExists('organizationApiUpdateOrganizationToPremium', 'updateOrgToPremiumBody', updateOrgToPremiumBody)
            const localVarPath = `/admin/org/{org_id}/premium`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrgToPremiumBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} userId 
         * @param {UpdateOrgUserBody} updateOrgUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganizationUser: async (orgId: string, userId: string, updateOrgUserBody: UpdateOrgUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationApiUpdateOrganizationUser', 'orgId', orgId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationApiUpdateOrganizationUser', 'userId', userId)
            // verify required parameter 'updateOrgUserBody' is not null or undefined
            assertParamExists('organizationApiUpdateOrganizationUser', 'updateOrgUserBody', updateOrgUserBody)
            const localVarPath = `/org/{org_id}/user/{user_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrgUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {string} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUploadOrganizationLogo: async (imageFile: File, orgId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('organizationApiUploadOrganizationLogo', 'imageFile', imageFile)
            const localVarPath = `/org/upload-logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApiApi - functional programming interface
 */
export const OrganizationApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiActivateOrganizationStatus(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiActivateOrganizationStatus(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiActivateOrganizationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AddUsersToOrganizationBody} addUsersToOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAddUserToOrganization(orgId: string, addUsersToOrganizationBody: AddUsersToOrganizationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAddUserToOrganization(orgId, addUsersToOrganizationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAddUserToOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminCreateChatTemplateBody} adminCreateChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAdminCreateChatTemplate(adminCreateChatTemplateBody: AdminCreateChatTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAdminCreateChatTemplate(adminCreateChatTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAdminCreateChatTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAdminDeleteChatTemplateById(chatTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAdminDeleteChatTemplateById(chatTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAdminDeleteChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAdminGetChatTemplateById(chatTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAdminGetChatTemplateById(chatTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAdminGetChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAdminGetChatTemplateList(page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllChatTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAdminGetChatTemplateList(page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAdminGetChatTemplateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {AdminCreateChatTemplateBody} adminCreateChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiAdminUpdateChatTemplateById(chatTemplateId: string, adminCreateChatTemplateBody: AdminCreateChatTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiAdminUpdateChatTemplateById(chatTemplateId, adminCreateChatTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiAdminUpdateChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkUpdateOrgBody} bulkUpdateOrgBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiBulkUpdateOrganizationStatus(bulkUpdateOrgBody: BulkUpdateOrgBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiBulkUpdateOrganizationStatus(bulkUpdateOrgBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiBulkUpdateOrganizationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {RoleChangeBody} roleChangeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiChangeOrgUserRole(orgId: string, roleChangeBody: RoleChangeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiChangeOrgUserRole(orgId, roleChangeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiChangeOrgUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateChatTemplateBody} createChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiCreateChatTemplate(orgId: string, createChatTemplateBody: CreateChatTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiCreateChatTemplate(orgId, createChatTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiCreateChatTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOrganizationBody} createOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiCreateOrganization(createOrganizationBody: CreateOrganizationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationListSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiCreateOrganization(createOrganizationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiCreateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiDeleteChatTemplateById(chatTemplateId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiDeleteChatTemplateById(chatTemplateId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiDeleteChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetChatTemplateById(chatTemplateId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetChatTemplateById(chatTemplateId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetChatTemplateList(orgId: string, page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllChatTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetChatTemplateList(orgId, page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetChatTemplateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetCompanyAccessibleUsers(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationUsersListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetCompanyAccessibleUsers(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetCompanyAccessibleUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrgUser(orgId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationUsersListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrgUser(orgId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrgUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrganizationById(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationListSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrganizationById(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrganizationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attribute 
         * @param {string} [orgId] 
         * @param {string} [orgUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrganizationContactDetails(attribute: string, orgId?: string, orgUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationContactDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrganizationContactDetails(attribute, orgId, orgUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrganizationContactDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [document] 
         * @param {string} [endDate] 
         * @param {OrganizationApiGetOrganizationCsvFreeUnlockEnum} [freeUnlock] 
         * @param {string | null} [freeUnlockOfferId] 
         * @param {number | null} [maxJobPosted] 
         * @param {number | null} [minApplicants] 
         * @param {number | null} [minJobPosted] 
         * @param {string} [name] 
         * @param {string | null} [planType] 
         * @param {string} [startDate] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrganizationCsv(document?: boolean, endDate?: string, freeUnlock?: OrganizationApiGetOrganizationCsvFreeUnlockEnum, freeUnlockOfferId?: string | null, maxJobPosted?: number | null, minApplicants?: number | null, minJobPosted?: number | null, name?: string, planType?: string | null, startDate?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrganizationCsv(document, endDate, freeUnlock, freeUnlockOfferId, maxJobPosted, minApplicants, minJobPosted, name, planType, startDate, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrganizationCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrganizationList(name?: string, page?: string, pageSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrganizationList(name, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrganizationList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetOrganizationUsers(orgId: string, companyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationUsersListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetOrganizationUsers(orgId, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetOrganizationUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetPendingOrganizationList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetPendingOrganizationList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetPendingOrganizationList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetPlanById(planId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetPlanById(planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetPlanById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [planType] 
         * @param {string} [query] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetPlanListPublic(page?: number, pageSize?: number, planType?: string, query?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetPlanListPublic(page, pageSize, planType, query, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetPlanListPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [planType] 
         * @param {string} [query] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetTrialPlanList(page?: number, pageSize?: number, planType?: string, query?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetTrialPlanList(page, pageSize, planType, query, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetTrialPlanList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiGetVerificationDoc(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiGetVerificationDoc(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiGetVerificationDoc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiHardDeleteOrganization(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiHardDeleteOrganization(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiHardDeleteOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {InviteOrgMembersBody} inviteOrgMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiInviteOrganizationMembers(orgId: string, inviteOrgMembersBody: InviteOrgMembersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiInviteOrganizationMembers(orgId, inviteOrgMembersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiInviteOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teamName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiIsTeamNameAvailable(companyId: string, teamName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamNameAvailibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiIsTeamNameAvailable(companyId, teamName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiIsTeamNameAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiMarkOrganizationDelete(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiMarkOrganizationDelete(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiMarkOrganizationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiOrgAutocomplete(pageNo?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiOrgAutocomplete(pageNo, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiOrgAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiRemoveOrganizationMembers(email: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiRemoveOrganizationMembers(email, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiRemoveOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [document] 
         * @param {string | null} [endDate] 
         * @param {OrganizationApiReviewOrganizationsFreeUnlockEnum} [freeUnlock] 
         * @param {string | null} [freeUnlockOfferId] 
         * @param {boolean | null} [isPlacementPartner] 
         * @param {number | null} [maxJobPosted] 
         * @param {number | null} [minActivityCount] 
         * @param {number | null} [minApplicants] 
         * @param {number | null} [minJobPosted] 
         * @param {string | null} [orgId] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string | null} [planType] 
         * @param {string} [searchQuery] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiReviewOrganizations(document?: boolean, endDate?: string | null, freeUnlock?: OrganizationApiReviewOrganizationsFreeUnlockEnum, freeUnlockOfferId?: string | null, isPlacementPartner?: boolean | null, maxJobPosted?: number | null, minActivityCount?: number | null, minApplicants?: number | null, minJobPosted?: number | null, orgId?: string | null, page?: string, pageSize?: string, planType?: string | null, searchQuery?: string, sortBy?: string, sortOrder?: string, startDate?: string | null, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiReviewOrganizations(document, endDate, freeUnlock, freeUnlockOfferId, isPlacementPartner, maxJobPosted, minActivityCount, minApplicants, minJobPosted, orgId, page, pageSize, planType, searchQuery, sortBy, sortOrder, startDate, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiReviewOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiStartTrialPlan(orgId: string, planId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiStartTrialPlan(orgId, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiStartTrialPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newOwnerUserId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiTransferOwnership(newOwnerUserId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiTransferOwnership(newOwnerUserId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiTransferOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiTriggerDocumentStatusMail(orgId: string, status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiTriggerDocumentStatusMail(orgId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiTriggerDocumentStatusMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {MemberAcceptanceBody} memberAcceptanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateAcceptanceStatus(orgId: string, memberAcceptanceBody: MemberAcceptanceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateAcceptanceStatus(orgId, memberAcceptanceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateAcceptanceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatTemplateId 
         * @param {string} orgId 
         * @param {CreateChatTemplateBody} createChatTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateChatTemplateById(chatTemplateId: string, orgId: string, createChatTemplateBody: CreateChatTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateChatTemplateById(chatTemplateId, orgId, createChatTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateChatTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateMemberResignation(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateMemberResignation(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateMemberResignation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {UpdateOrganizationBody} updateOrganizationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateOrganization(orgId: string, updateOrganizationBody: UpdateOrganizationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationListSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateOrganization(orgId, updateOrganizationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {UpdateOrgToPremiumBody} updateOrgToPremiumBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateOrganizationToPremium(orgId: string, updateOrgToPremiumBody: UpdateOrgToPremiumBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationListSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateOrganizationToPremium(orgId, updateOrgToPremiumBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateOrganizationToPremium']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} userId 
         * @param {UpdateOrgUserBody} updateOrgUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUpdateOrganizationUser(orgId: string, userId: string, updateOrgUserBody: UpdateOrgUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUpdateOrganizationUser(orgId, userId, updateOrgUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUpdateOrganizationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {string} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationApiUploadOrganizationLogo(imageFile: File, orgId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationApiUploadOrganizationLogo(imageFile, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApiApi.organizationApiUploadOrganizationLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationApiApi - factory interface
 */
export const OrganizationApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiApiFp(configuration)
    return {
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiActivateOrganizationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiActivateOrganizationStatus(requestParameters: OrganizationApiApiOrganizationApiActivateOrganizationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationApiActivateOrganizationStatus(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAddUserToOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAddUserToOrganization(requestParameters: OrganizationApiApiOrganizationApiAddUserToOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiAddUserToOrganization(requestParameters.orgId, requestParameters.addUsersToOrganizationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAdminCreateChatTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminCreateChatTemplate(requestParameters: OrganizationApiApiOrganizationApiAdminCreateChatTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiAdminCreateChatTemplate(requestParameters.adminCreateChatTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAdminDeleteChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminDeleteChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminDeleteChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiAdminDeleteChatTemplateById(requestParameters.chatTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAdminGetChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminGetChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminGetChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiAdminGetChatTemplateById(requestParameters.chatTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAdminGetChatTemplateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminGetChatTemplateList(requestParameters: OrganizationApiApiOrganizationApiAdminGetChatTemplateListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllChatTemplatesResponse> {
            return localVarFp.organizationApiAdminGetChatTemplateList(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiAdminUpdateChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiAdminUpdateChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminUpdateChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiAdminUpdateChatTemplateById(requestParameters.chatTemplateId, requestParameters.adminCreateChatTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiBulkUpdateOrganizationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiBulkUpdateOrganizationStatus(requestParameters: OrganizationApiApiOrganizationApiBulkUpdateOrganizationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiBulkUpdateOrganizationStatus(requestParameters.bulkUpdateOrgBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiChangeOrgUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiChangeOrgUserRole(requestParameters: OrganizationApiApiOrganizationApiChangeOrgUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiChangeOrgUserRole(requestParameters.orgId, requestParameters.roleChangeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiCreateChatTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiCreateChatTemplate(requestParameters: OrganizationApiApiOrganizationApiCreateChatTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiCreateChatTemplate(requestParameters.orgId, requestParameters.createChatTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiCreateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiCreateOrganization(requestParameters: OrganizationApiApiOrganizationApiCreateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationListSub> {
            return localVarFp.organizationApiCreateOrganization(requestParameters.createOrganizationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiDeleteChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiDeleteChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiDeleteChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiDeleteChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiGetChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiGetChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetChatTemplateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetChatTemplateList(requestParameters: OrganizationApiApiOrganizationApiGetChatTemplateListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllChatTemplatesResponse> {
            return localVarFp.organizationApiGetChatTemplateList(requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetCompanyAccessibleUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetCompanyAccessibleUsers(requestParameters: OrganizationApiApiOrganizationApiGetCompanyAccessibleUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetOrganizationUsersListResponse>> {
            return localVarFp.organizationApiGetCompanyAccessibleUsers(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrgUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrgUser(requestParameters: OrganizationApiApiOrganizationApiGetOrgUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationUsersListResponse> {
            return localVarFp.organizationApiGetOrgUser(requestParameters.orgId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrganizationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationById(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationListSub> {
            return localVarFp.organizationApiGetOrganizationById(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrganizationContactDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationContactDetails(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationContactDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationContactDetailsResponse> {
            return localVarFp.organizationApiGetOrganizationContactDetails(requestParameters.attribute, requestParameters.orgId, requestParameters.orgUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrganizationCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationCsv(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationCsvRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationApiGetOrganizationCsv(requestParameters.document, requestParameters.endDate, requestParameters.freeUnlock, requestParameters.freeUnlockOfferId, requestParameters.maxJobPosted, requestParameters.minApplicants, requestParameters.minJobPosted, requestParameters.name, requestParameters.planType, requestParameters.startDate, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrganizationListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationList(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOrgListResponse> {
            return localVarFp.organizationApiGetOrganizationList(requestParameters.name, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetOrganizationUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetOrganizationUsers(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetOrganizationUsersListResponse>> {
            return localVarFp.organizationApiGetOrganizationUsers(requestParameters.orgId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPendingOrganizationList(options?: RawAxiosRequestConfig): AxiosPromise<GetOrgListResponse> {
            return localVarFp.organizationApiGetPendingOrganizationList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetPlanByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPlanById(requestParameters: OrganizationApiApiOrganizationApiGetPlanByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePlanResponse> {
            return localVarFp.organizationApiGetPlanById(requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetPlanListPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetPlanListPublic(requestParameters: OrganizationApiApiOrganizationApiGetPlanListPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllPlansResponse> {
            return localVarFp.organizationApiGetPlanListPublic(requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.query, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetTrialPlanListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetTrialPlanList(requestParameters: OrganizationApiApiOrganizationApiGetTrialPlanListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllPlansResponse> {
            return localVarFp.organizationApiGetTrialPlanList(requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.query, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiGetVerificationDocRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiGetVerificationDoc(requestParameters: OrganizationApiApiOrganizationApiGetVerificationDocRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.organizationApiGetVerificationDoc(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiHardDeleteOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiHardDeleteOrganization(requestParameters: OrganizationApiApiOrganizationApiHardDeleteOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiHardDeleteOrganization(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiInviteOrganizationMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiInviteOrganizationMembers(requestParameters: OrganizationApiApiOrganizationApiInviteOrganizationMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiInviteOrganizationMembers(requestParameters.orgId, requestParameters.inviteOrgMembersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiIsTeamNameAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiIsTeamNameAvailable(requestParameters: OrganizationApiApiOrganizationApiIsTeamNameAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamNameAvailibilityResponse> {
            return localVarFp.organizationApiIsTeamNameAvailable(requestParameters.companyId, requestParameters.teamName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiMarkOrganizationDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiMarkOrganizationDelete(requestParameters: OrganizationApiApiOrganizationApiMarkOrganizationDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.organizationApiMarkOrganizationDelete(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiOrgAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiOrgAutocomplete(requestParameters: OrganizationApiApiOrganizationApiOrgAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrgAutocompleteResponse> {
            return localVarFp.organizationApiOrgAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiRemoveOrganizationMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiRemoveOrganizationMembers(requestParameters: OrganizationApiApiOrganizationApiRemoveOrganizationMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiRemoveOrganizationMembers(requestParameters.email, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiReviewOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiReviewOrganizations(requestParameters: OrganizationApiApiOrganizationApiReviewOrganizationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReviewOrganizationResponse> {
            return localVarFp.organizationApiReviewOrganizations(requestParameters.document, requestParameters.endDate, requestParameters.freeUnlock, requestParameters.freeUnlockOfferId, requestParameters.isPlacementPartner, requestParameters.maxJobPosted, requestParameters.minActivityCount, requestParameters.minApplicants, requestParameters.minJobPosted, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.searchQuery, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiStartTrialPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiStartTrialPlan(requestParameters: OrganizationApiApiOrganizationApiStartTrialPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiStartTrialPlan(requestParameters.orgId, requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiTransferOwnershipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiTransferOwnership(requestParameters: OrganizationApiApiOrganizationApiTransferOwnershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiTransferOwnership(requestParameters.newOwnerUserId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiTriggerDocumentStatusMailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiTriggerDocumentStatusMail(requestParameters: OrganizationApiApiOrganizationApiTriggerDocumentStatusMailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiTriggerDocumentStatusMail(requestParameters.orgId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateAcceptanceStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateAcceptanceStatus(requestParameters: OrganizationApiApiOrganizationApiUpdateAcceptanceStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiUpdateAcceptanceStatus(requestParameters.orgId, requestParameters.memberAcceptanceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateChatTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiUpdateChatTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatTemplateResponse> {
            return localVarFp.organizationApiUpdateChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, requestParameters.createChatTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateMemberResignationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateMemberResignation(requestParameters: OrganizationApiApiOrganizationApiUpdateMemberResignationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiUpdateMemberResignation(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganization(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationListSub> {
            return localVarFp.organizationApiUpdateOrganization(requestParameters.orgId, requestParameters.updateOrganizationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateOrganizationToPremiumRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganizationToPremium(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationToPremiumRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationListSub> {
            return localVarFp.organizationApiUpdateOrganizationToPremium(requestParameters.orgId, requestParameters.updateOrgToPremiumBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUpdateOrganizationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUpdateOrganizationUser(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.organizationApiUpdateOrganizationUser(requestParameters.orgId, requestParameters.userId, requestParameters.updateOrgUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationApiApiOrganizationApiUploadOrganizationLogoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationApiUploadOrganizationLogo(requestParameters: OrganizationApiApiOrganizationApiUploadOrganizationLogoRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.organizationApiUploadOrganizationLogo(requestParameters.imageFile, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationApiActivateOrganizationStatus operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiActivateOrganizationStatusRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiAddUserToOrganization operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAddUserToOrganizationRequest {
    readonly orgId: string

    readonly addUsersToOrganizationBody: AddUsersToOrganizationBody
}

/**
 * Request parameters for organizationApiAdminCreateChatTemplate operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAdminCreateChatTemplateRequest {
    readonly adminCreateChatTemplateBody: AdminCreateChatTemplateBody
}

/**
 * Request parameters for organizationApiAdminDeleteChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAdminDeleteChatTemplateByIdRequest {
    readonly chatTemplateId: string
}

/**
 * Request parameters for organizationApiAdminGetChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAdminGetChatTemplateByIdRequest {
    readonly chatTemplateId: string
}

/**
 * Request parameters for organizationApiAdminGetChatTemplateList operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAdminGetChatTemplateListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for organizationApiAdminUpdateChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiAdminUpdateChatTemplateByIdRequest {
    readonly chatTemplateId: string

    readonly adminCreateChatTemplateBody: AdminCreateChatTemplateBody
}

/**
 * Request parameters for organizationApiBulkUpdateOrganizationStatus operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiBulkUpdateOrganizationStatusRequest {
    readonly bulkUpdateOrgBody: BulkUpdateOrgBody
}

/**
 * Request parameters for organizationApiChangeOrgUserRole operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiChangeOrgUserRoleRequest {
    readonly orgId: string

    readonly roleChangeBody: RoleChangeBody
}

/**
 * Request parameters for organizationApiCreateChatTemplate operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiCreateChatTemplateRequest {
    readonly orgId: string

    readonly createChatTemplateBody: CreateChatTemplateBody
}

/**
 * Request parameters for organizationApiCreateOrganization operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiCreateOrganizationRequest {
    readonly createOrganizationBody: CreateOrganizationBody
}

/**
 * Request parameters for organizationApiDeleteChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiDeleteChatTemplateByIdRequest {
    readonly chatTemplateId: string

    readonly orgId: string
}

/**
 * Request parameters for organizationApiGetChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetChatTemplateByIdRequest {
    readonly chatTemplateId: string

    readonly orgId: string
}

/**
 * Request parameters for organizationApiGetChatTemplateList operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetChatTemplateListRequest {
    readonly orgId: string

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for organizationApiGetCompanyAccessibleUsers operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetCompanyAccessibleUsersRequest {
    readonly companyId: string
}

/**
 * Request parameters for organizationApiGetOrgUser operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrgUserRequest {
    readonly orgId: string

    readonly userId: string
}

/**
 * Request parameters for organizationApiGetOrganizationById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrganizationByIdRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiGetOrganizationContactDetails operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrganizationContactDetailsRequest {
    readonly attribute: string

    readonly orgId?: string

    readonly orgUserId?: string
}

/**
 * Request parameters for organizationApiGetOrganizationCsv operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrganizationCsvRequest {
    readonly document?: boolean

    readonly endDate?: string

    readonly freeUnlock?: OrganizationApiGetOrganizationCsvFreeUnlockEnum

    readonly freeUnlockOfferId?: string | null

    readonly maxJobPosted?: number | null

    readonly minApplicants?: number | null

    readonly minJobPosted?: number | null

    readonly name?: string

    readonly planType?: string | null

    readonly startDate?: string

    readonly status?: string
}

/**
 * Request parameters for organizationApiGetOrganizationList operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrganizationListRequest {
    readonly name?: string

    readonly page?: string

    readonly pageSize?: string
}

/**
 * Request parameters for organizationApiGetOrganizationUsers operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetOrganizationUsersRequest {
    readonly orgId: string

    readonly companyId?: string
}

/**
 * Request parameters for organizationApiGetPlanById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetPlanByIdRequest {
    readonly planId: string
}

/**
 * Request parameters for organizationApiGetPlanListPublic operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetPlanListPublicRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly planType?: string

    readonly query?: string

    readonly status?: string
}

/**
 * Request parameters for organizationApiGetTrialPlanList operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetTrialPlanListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly planType?: string

    readonly query?: string

    readonly status?: string
}

/**
 * Request parameters for organizationApiGetVerificationDoc operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiGetVerificationDocRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiHardDeleteOrganization operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiHardDeleteOrganizationRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiInviteOrganizationMembers operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiInviteOrganizationMembersRequest {
    readonly orgId: string

    readonly inviteOrgMembersBody: InviteOrgMembersBody
}

/**
 * Request parameters for organizationApiIsTeamNameAvailable operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiIsTeamNameAvailableRequest {
    readonly companyId: string

    readonly teamName: string
}

/**
 * Request parameters for organizationApiMarkOrganizationDelete operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiMarkOrganizationDeleteRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiOrgAutocomplete operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiOrgAutocompleteRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for organizationApiRemoveOrganizationMembers operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiRemoveOrganizationMembersRequest {
    readonly email: string

    readonly orgId: string
}

/**
 * Request parameters for organizationApiReviewOrganizations operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiReviewOrganizationsRequest {
    readonly document?: boolean

    readonly endDate?: string | null

    readonly freeUnlock?: OrganizationApiReviewOrganizationsFreeUnlockEnum

    readonly freeUnlockOfferId?: string | null

    readonly isPlacementPartner?: boolean | null

    readonly maxJobPosted?: number | null

    readonly minActivityCount?: number | null

    readonly minApplicants?: number | null

    readonly minJobPosted?: number | null

    readonly orgId?: string | null

    readonly page?: string

    readonly pageSize?: string

    readonly planType?: string | null

    readonly searchQuery?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly startDate?: string | null

    readonly status?: string
}

/**
 * Request parameters for organizationApiStartTrialPlan operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiStartTrialPlanRequest {
    readonly orgId: string

    readonly planId: string
}

/**
 * Request parameters for organizationApiTransferOwnership operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiTransferOwnershipRequest {
    readonly newOwnerUserId: string

    readonly orgId: string
}

/**
 * Request parameters for organizationApiTriggerDocumentStatusMail operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiTriggerDocumentStatusMailRequest {
    readonly orgId: string

    readonly status: string
}

/**
 * Request parameters for organizationApiUpdateAcceptanceStatus operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateAcceptanceStatusRequest {
    readonly orgId: string

    readonly memberAcceptanceBody: MemberAcceptanceBody
}

/**
 * Request parameters for organizationApiUpdateChatTemplateById operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateChatTemplateByIdRequest {
    readonly chatTemplateId: string

    readonly orgId: string

    readonly createChatTemplateBody: CreateChatTemplateBody
}

/**
 * Request parameters for organizationApiUpdateMemberResignation operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateMemberResignationRequest {
    readonly orgId: string
}

/**
 * Request parameters for organizationApiUpdateOrganization operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateOrganizationRequest {
    readonly orgId: string

    readonly updateOrganizationBody: UpdateOrganizationBody
}

/**
 * Request parameters for organizationApiUpdateOrganizationToPremium operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateOrganizationToPremiumRequest {
    readonly orgId: string

    readonly updateOrgToPremiumBody: UpdateOrgToPremiumBody
}

/**
 * Request parameters for organizationApiUpdateOrganizationUser operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUpdateOrganizationUserRequest {
    readonly orgId: string

    readonly userId: string

    readonly updateOrgUserBody: UpdateOrgUserBody
}

/**
 * Request parameters for organizationApiUploadOrganizationLogo operation in OrganizationApiApi.
 */
export interface OrganizationApiApiOrganizationApiUploadOrganizationLogoRequest {
    readonly imageFile: File

    readonly orgId?: string
}

/**
 * OrganizationApiApi - object-oriented interface
 */
export class OrganizationApiApi extends BaseAPI {
    /**
     * 
     * @param {OrganizationApiApiOrganizationApiActivateOrganizationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiActivateOrganizationStatus(requestParameters: OrganizationApiApiOrganizationApiActivateOrganizationStatusRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiActivateOrganizationStatus(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAddUserToOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAddUserToOrganization(requestParameters: OrganizationApiApiOrganizationApiAddUserToOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAddUserToOrganization(requestParameters.orgId, requestParameters.addUsersToOrganizationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAdminCreateChatTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAdminCreateChatTemplate(requestParameters: OrganizationApiApiOrganizationApiAdminCreateChatTemplateRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAdminCreateChatTemplate(requestParameters.adminCreateChatTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAdminDeleteChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAdminDeleteChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminDeleteChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAdminDeleteChatTemplateById(requestParameters.chatTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAdminGetChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAdminGetChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminGetChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAdminGetChatTemplateById(requestParameters.chatTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAdminGetChatTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAdminGetChatTemplateList(requestParameters: OrganizationApiApiOrganizationApiAdminGetChatTemplateListRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAdminGetChatTemplateList(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiAdminUpdateChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiAdminUpdateChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiAdminUpdateChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiAdminUpdateChatTemplateById(requestParameters.chatTemplateId, requestParameters.adminCreateChatTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiBulkUpdateOrganizationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiBulkUpdateOrganizationStatus(requestParameters: OrganizationApiApiOrganizationApiBulkUpdateOrganizationStatusRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiBulkUpdateOrganizationStatus(requestParameters.bulkUpdateOrgBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiChangeOrgUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiChangeOrgUserRole(requestParameters: OrganizationApiApiOrganizationApiChangeOrgUserRoleRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiChangeOrgUserRole(requestParameters.orgId, requestParameters.roleChangeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiCreateChatTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiCreateChatTemplate(requestParameters: OrganizationApiApiOrganizationApiCreateChatTemplateRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiCreateChatTemplate(requestParameters.orgId, requestParameters.createChatTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiCreateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiCreateOrganization(requestParameters: OrganizationApiApiOrganizationApiCreateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiCreateOrganization(requestParameters.createOrganizationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiDeleteChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiDeleteChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiDeleteChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiDeleteChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiGetChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetChatTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetChatTemplateList(requestParameters: OrganizationApiApiOrganizationApiGetChatTemplateListRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetChatTemplateList(requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetCompanyAccessibleUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetCompanyAccessibleUsers(requestParameters: OrganizationApiApiOrganizationApiGetCompanyAccessibleUsersRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetCompanyAccessibleUsers(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrgUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrgUser(requestParameters: OrganizationApiApiOrganizationApiGetOrgUserRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrgUser(requestParameters.orgId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrganizationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrganizationById(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrganizationById(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrganizationContactDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrganizationContactDetails(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationContactDetailsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrganizationContactDetails(requestParameters.attribute, requestParameters.orgId, requestParameters.orgUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrganizationCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrganizationCsv(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationCsvRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrganizationCsv(requestParameters.document, requestParameters.endDate, requestParameters.freeUnlock, requestParameters.freeUnlockOfferId, requestParameters.maxJobPosted, requestParameters.minApplicants, requestParameters.minJobPosted, requestParameters.name, requestParameters.planType, requestParameters.startDate, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrganizationListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrganizationList(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationListRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrganizationList(requestParameters.name, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetOrganizationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetOrganizationUsers(requestParameters: OrganizationApiApiOrganizationApiGetOrganizationUsersRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetOrganizationUsers(requestParameters.orgId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetPendingOrganizationList(options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetPendingOrganizationList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetPlanByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetPlanById(requestParameters: OrganizationApiApiOrganizationApiGetPlanByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetPlanById(requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetPlanListPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetPlanListPublic(requestParameters: OrganizationApiApiOrganizationApiGetPlanListPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetPlanListPublic(requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.query, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetTrialPlanListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetTrialPlanList(requestParameters: OrganizationApiApiOrganizationApiGetTrialPlanListRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetTrialPlanList(requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.query, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiGetVerificationDocRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiGetVerificationDoc(requestParameters: OrganizationApiApiOrganizationApiGetVerificationDocRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiGetVerificationDoc(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiHardDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiHardDeleteOrganization(requestParameters: OrganizationApiApiOrganizationApiHardDeleteOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiHardDeleteOrganization(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiInviteOrganizationMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiInviteOrganizationMembers(requestParameters: OrganizationApiApiOrganizationApiInviteOrganizationMembersRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiInviteOrganizationMembers(requestParameters.orgId, requestParameters.inviteOrgMembersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiIsTeamNameAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiIsTeamNameAvailable(requestParameters: OrganizationApiApiOrganizationApiIsTeamNameAvailableRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiIsTeamNameAvailable(requestParameters.companyId, requestParameters.teamName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiMarkOrganizationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiMarkOrganizationDelete(requestParameters: OrganizationApiApiOrganizationApiMarkOrganizationDeleteRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiMarkOrganizationDelete(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiOrgAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiOrgAutocomplete(requestParameters: OrganizationApiApiOrganizationApiOrgAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiOrgAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiRemoveOrganizationMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiRemoveOrganizationMembers(requestParameters: OrganizationApiApiOrganizationApiRemoveOrganizationMembersRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiRemoveOrganizationMembers(requestParameters.email, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiReviewOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiReviewOrganizations(requestParameters: OrganizationApiApiOrganizationApiReviewOrganizationsRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiReviewOrganizations(requestParameters.document, requestParameters.endDate, requestParameters.freeUnlock, requestParameters.freeUnlockOfferId, requestParameters.isPlacementPartner, requestParameters.maxJobPosted, requestParameters.minActivityCount, requestParameters.minApplicants, requestParameters.minJobPosted, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.planType, requestParameters.searchQuery, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiStartTrialPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiStartTrialPlan(requestParameters: OrganizationApiApiOrganizationApiStartTrialPlanRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiStartTrialPlan(requestParameters.orgId, requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiTransferOwnershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiTransferOwnership(requestParameters: OrganizationApiApiOrganizationApiTransferOwnershipRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiTransferOwnership(requestParameters.newOwnerUserId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiTriggerDocumentStatusMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiTriggerDocumentStatusMail(requestParameters: OrganizationApiApiOrganizationApiTriggerDocumentStatusMailRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiTriggerDocumentStatusMail(requestParameters.orgId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateAcceptanceStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateAcceptanceStatus(requestParameters: OrganizationApiApiOrganizationApiUpdateAcceptanceStatusRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateAcceptanceStatus(requestParameters.orgId, requestParameters.memberAcceptanceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateChatTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateChatTemplateById(requestParameters: OrganizationApiApiOrganizationApiUpdateChatTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateChatTemplateById(requestParameters.chatTemplateId, requestParameters.orgId, requestParameters.createChatTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateMemberResignationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateMemberResignation(requestParameters: OrganizationApiApiOrganizationApiUpdateMemberResignationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateMemberResignation(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateOrganization(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateOrganization(requestParameters.orgId, requestParameters.updateOrganizationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateOrganizationToPremiumRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateOrganizationToPremium(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationToPremiumRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateOrganizationToPremium(requestParameters.orgId, requestParameters.updateOrgToPremiumBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUpdateOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUpdateOrganizationUser(requestParameters: OrganizationApiApiOrganizationApiUpdateOrganizationUserRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUpdateOrganizationUser(requestParameters.orgId, requestParameters.userId, requestParameters.updateOrgUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationApiApiOrganizationApiUploadOrganizationLogoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public organizationApiUploadOrganizationLogo(requestParameters: OrganizationApiApiOrganizationApiUploadOrganizationLogoRequest, options?: RawAxiosRequestConfig) {
        return OrganizationApiApiFp(this.configuration).organizationApiUploadOrganizationLogo(requestParameters.imageFile, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const OrganizationApiGetOrganizationCsvFreeUnlockEnum = {
    Invited: 'invited',
    Activated: 'activated',
    InvitedNotActivated: 'invited_not_activated',
    NotInvited: 'not_invited',
} as const;
export type OrganizationApiGetOrganizationCsvFreeUnlockEnum = typeof OrganizationApiGetOrganizationCsvFreeUnlockEnum[keyof typeof OrganizationApiGetOrganizationCsvFreeUnlockEnum];
export const OrganizationApiReviewOrganizationsFreeUnlockEnum = {
    Invited: 'invited',
    Activated: 'activated',
    InvitedNotActivated: 'invited_not_activated',
    NotInvited: 'not_invited',
} as const;
export type OrganizationApiReviewOrganizationsFreeUnlockEnum = typeof OrganizationApiReviewOrganizationsFreeUnlockEnum[keyof typeof OrganizationApiReviewOrganizationsFreeUnlockEnum];
